import { createRouter, createWebHistory } from "vue-router";
import authGuard from "@/guards/authGuard";
import permissionsGuard from "@/guards/permissionsGuard";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Authentication
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login.vue"),
      beforeEnter: authGuard,
    },
    // Authenticated routes
    {
      path: "/",
      name: "Dashboard",
      component: () => import("@/views/Dashboard.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/occupancy",
      name: "Occupancy",
      component: () => import("@/views/Occupancy.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/validation",
      name: "Validation",
      component: () => import("@/views/Validation.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/front-desk",
      name: "FrontDesk",
      component: () => import("@/views/FrontDesk.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/valet-insights",
      name: "ValetInsights",
      component: () => import("@/views/ValetInsights.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/daily-location-summary",
      name: "DailyLocationSummary",
      component: () => import("@/views/DailyLocationSummary.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/front-desk/start-parking-session",
      name: "StartParkingSession",
      component: () => import("@/views/StartParkingSession.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/event",
      name: "Event",
      component: () => import("@/views/Event.vue"),
      beforeEnter: [authGuard, permissionsGuard],
    },
    {
      path: "/parking/lots",
      name: "Parking Lots",
      component: () => import("@/views/PageParkingLots.vue"),
      beforeEnter: authGuard,
    },
    {
      path: "/parking/lots/:lotId",
      component: () => import("@/views/PageParkingLot.vue"),
      beforeEnter: authGuard,
      props: true,
    },
    {
      path: "/reporting",
      name: "Reporting",
      component: () => import("@/views/PageReporting.vue"),
      redirect: { name: "Run Report" },
      beforeEnter: [authGuard, permissionsGuard],
      children: [
        {
          path: "run",
          name: "Run Report",
          component: () => import("@/views/PageRunReport.vue"),
        },
        {
          path: "schedule",
          name: "Schedule Report",
          component: () => import("@/views/PageScheduleReport.vue"),
        },
      ],
    },
  ],
});

export default router;
